module.exports = __webpack_public_path__ + "static/media/A3.ae0dbddb.jpg";